import { render } from "./SwiperButton.vue?vue&type=template&id=0905f49a&scoped=true"
const script = {}

import "./SwiperButton.vue?vue&type=style&index=0&id=0905f49a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0905f49a"]])

export default __exports__